import { Box, Grid, Typography } from "@material-ui/core"
import { AccordionSaurus } from "views/components/accordions/accordion-saurus/accordion-saurus"
import { memo, useState, useCallback, useMemo } from "react"
import { LogLogModel } from "model/api/gestao/clickup/log-log-model"
import { useStyles } from "./accordion-historico-atualizacoes-styles"
import { HistoricoVersaoLogsProps } from "../../historico-atualizacoes-list-data"
import { useThemeQueries } from "views/theme"
import { CardHistoricoAtualizacoes } from "views/components/cards/card-historico-atualizacoes/card-historico-atualizacoes"
import { DataVersao } from "./components/data-versao/data-versao"

interface AccordionHistoricoAtualizacoesProps {
    backlog: HistoricoVersaoLogsProps
    index: number
}

const DATA_HORA_DESCRICAO_REGEX = /(\d{2}\/\d{2}\/\d{4}\s+\d{2}:\d{2}:\d{2})/

function extractDateFromDescricao(descricao: string): Date | null {
    const match = descricao?.match(DATA_HORA_DESCRICAO_REGEX)
    if (!match) return null

    const [datePart, timePart] = match[1].split(' ')
    const [day, month, year] = datePart.split('/').map(Number)
    const [hours, minutes, seconds] = timePart.split(':').map(Number)
    const parsed = new Date(year, month - 1, day, hours, minutes, seconds)

    return Number.isNaN(parsed.getTime()) ? null : parsed
}

function sortTarefasByDescricaoDate(tarefas: LogLogModel[]): LogLogModel[] {
    return [...tarefas].sort((a, b) => {
        const dateA = extractDateFromDescricao(a.descricao)
        const dateB = extractDateFromDescricao(b.descricao)

        if (!dateA && !dateB) return 0
        if (!dateA) return 1
        if (!dateB) return -1

        return dateB.getTime() - dateA.getTime()
    })
}

export const AccordionHistoricoAtualizacoesVersao = memo(({ backlog, index }: AccordionHistoricoAtualizacoesProps) => {
    const classes = useStyles()
    const { theme: { palette } } = useThemeQueries()

    const [expanded, setExpanded] = useState(() => index < 5);

    // Memoiza a função de alternar o estado de expansão
    const handleExpansionChange = useCallback(() => {
        setExpanded(prev => !prev);
    }, []);

    const tarefasOrdenadas = useMemo(
        () => sortTarefasByDescricaoDate(backlog.logs),
        [backlog.logs]
    );

    return (
        <Box pt={index > 0 ? 1 : 0}>
            <AccordionSaurus
                labelPrimary={
                    <Typography className={classes.labelPrimary}>
                        <span>{backlog.versao.descricao}</span>
                    </Typography>
                }
                expanded={expanded}
                showDivider
                colorExpand={palette.primary.main}
                tipoExpand="bold"
                classesTitle={classes.titleAccordion}
                onChange={handleExpansionChange}
            >
                {expanded && (
                    <Grid container spacing={2}>
                        <Grid item xs={12} className={classes.contentDataVersao}>
                            <DataVersao data={backlog.versao.data_alfa} tipo='alfa' />
                            <DataVersao data={backlog.versao.data_beta} tipo='beta' />
                            <DataVersao data={backlog.versao.data_estavel} tipo='estavel' />
                        </Grid>
                        <Grid item xs={12}>
                            <Grid className={classes.tarefasContainer}>
                                <Grid className={classes.tarefas}>
                                    {tarefasOrdenadas.map((tarefa) => (
                                        <CardHistoricoAtualizacoes
                                            descricao={tarefa.descricao}
                                            link_clickup={tarefa.link_clickup}
                                            tipo_log={tarefa.tipo_log}
                                            titulo={tarefa.titulo}
                                            key={tarefa.id}
                                        />
                                    ))}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                )
                }
            </AccordionSaurus>
        </Box>
    )
})

AccordionHistoricoAtualizacoesVersao.displayName = 'AccordionHistoricoAtualizacoesVersao'